import React from 'react';
import SecurityPowerfulFeaturesItem from './SecurityPowerfulFeaturesItem';

const SecurityPowerFeatures =()=>(
    <section className="security_features_area">
        <div className="container">
            <div className="hosting_title security_title text-center">
                <h2 className="wow fadeInUp" data-wow-delay="0.2s"><span>Wi-Fi Access Point</span> Simple Yet Powerful</h2>
            </div>
            <div className="security_features_inner">
                <SecurityPowerfulFeaturesItem image="rocket.png" Title="Speed"/>
                <SecurityPowerfulFeaturesItem image="shield.png" Title="Protection"/>
                <SecurityPowerfulFeaturesItem image="real-estate.png" Title="Secure"/>
            </div>
        </div>
    </section>
)

export default SecurityPowerFeatures;